import { isNil, keyByValue, Nillable } from '@web/utils';
import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from '../models/table-column';
import { TableColumnType } from '../enums/table-column-type';

@Pipe({
  name: 'columnTypeCssClass',
  standalone: true,
})
export class ColumnTypeCssClassPipe<Item, Filter> implements PipeTransform {
  public transform(
    column: Nillable<TableColumn<Item, Filter>>,
  ): Nillable<string> {
    if (isNil(column)) {
      return;
    }

    const type = keyByValue(column.type, TableColumnType).toLowerCase();

    return `column-type-${type}`;
  }
}
